module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-nginx-01.6407d4c27d3ea19c9109fe530c77fd53.png";